var prueba;
var pruebafecha;
var vm1;

(function () {
    'use strict';
    var controllerId = 'appointmentMainGateCtrl';

    angular
        .module('app.controllers')
        .controller(controllerId, appointmentMainGateCtrl)
        .directive("datepicker", function () {
            return {
                restrict: "A",
                require: "ngModel",
                link: function (scope, elem, attrs, ngModelCtrl) {
                    var updateModel = function (dateText) {
                        scope.$apply(function () {
                            ngModelCtrl.$setViewValue(dateText);
                        });
                    };
                    var options = {
                        min: 0,
                        dateFormat: "dd/mm/yy",
                        autoclose: true,
                        onSelect: function (dateText) {
                            updateModel(dateText);
                        }
                    };
                    $(elem).datepicker(options);
                }
            }
        });

    appointmentMainGateCtrl.$inject = ['common', 'datacontext', '$http', '$scope', '$state', '$stateParams', '$translate', '$window', '$timeout', 'ngDialog', 'moment', '$rootScope', 'configConstants'];

    function appointmentMainGateCtrl(common, datacontext, $http, $scope, $state, $stateParams, $translate, $window, $timeout, ngDialog, moment, $rootScope, configConstants) {

        var responseAux;
        var lbl_All = $translate.instant('views.appointment.all');
        kendo.culture($translate.instant('views.appointmentScheduler.kendolang'));
        var formatos = ['D/M/YY', 'DD/M/YY', 'D/MM/YY', 'DD/MM/YY', 
            'D/M/YYYY', 'DD/M/YYYY', 'D/MM/YYYY', 'DD/MM/YYYY'];
   
        vm1 = this;

        vm1.spinnerOptions = {
            radius: 20,
            lines: 11,
            length: 1,
            width: 8,
            speed: 1.7,
            corners: 1.0,
            trail: 100,
            color: '#146794'
        };
        //vm1.actionRefresh = false;
        vm1.canReschedule = false;
        vm1.IsWeek = true;
        vm1.gotoCreate2 = gotoCreate2;
        vm1.deleteAppointment = deleteAppointment;
        vm1.searchnewAppointment = searchnewAppointment;
        vm1.varyard = {};
        vm1.yardsList = {};
        vm1.varoperationtype = {};
        vm1.codeOperationType = {};
        vm1.codeActionType = {};
        vm1.operationtypeList = {};
        vm1.varactiontype = {};
        vm1.actiontypeList = {};
        vm1.apptmodal = {};
        vm1.editdata = { 
            "Start": null,
            "TimeLimitType": null,
            "TimeLimitHours": null,
            "TimeLimitDate": null,
            "AppointmentId": 0,
            "AppointmentTemplateId": 0,
            "YardScheduleHourId": 0
        };
        vm1.current_view = "kendo.ui.AgendaView";
        vm1.roleSelected = "";
        vm1.isOnlyPortalUser = false;

        vm1.clickOpen = clickOpen;
        vm1.initialAction;

        vm1.datevalstart = new Date();
        vm1.datevalforhours = new Date();

        vm1.total = new Date();
        vm1.searchSchedulerModel;

        var getAppointments;

        vm1.deleteAppointmentModel;
        vm1.ActionT;

        // permissionHide se establece en init(), según tipo de acción (GTI ó GTO)
        //vm1.permissionHide = common.getPermissionByPage(configConstants.enums.pages.gateOut);
        

        vm1.yardSelected = yardSelected;
        vm1.actionTypeSelected = actionTypeSelected;
        vm1.operationTypeSelected = operationTypeSelected;
        vm1.principal = principal;
        vm1.redirectAction = redirectAction;
        vm1.showAppointmentModalDetails = showAppointmentModalDetails;
        vm1.downloadExcel = downloadExcel;

        vm1.startDate = startDate;
        vm1.startDatepicker = startDatepicker;
        vm1.startDateHours = startDateHours;
        vm1.startDatepickerHours = startDatepickerHours;
        vm1.saveReschedule = saveReschedule;
        vm1.showPrintApptView = showPrintApptView;
        vm1.showModal = showModal;
        vm1.gotoCreateModal = gotoCreateModal;
        vm1.copyToClipboard = copyToClipboard;

        vm1.checksForAppCreation = [];
        vm1.selectedApptsInfo = [];
        vm1.manageChecksForApptCreation = manageChecksForApptCreation;

        vm1.minDate = "";
        vm1.maxDate = "";
        vm1.yards = [];
        vm1.timeZoneWeb = "";

        var tempStart; var tempTimeLimitType; var tempTimeLimitHours; var tempTimeLimitDate; var tempAppointmentId; var tempAppointmentTemplateId;
        vm1.checkedValue = false;

        vm1.leadTime = 30;
        

        init();

        function manageChecksForApptCreation(elm, Start, TimeLimitType, TimeLimitHours, TimeLimitDate, AppointmentId, AppointmentTemplateId) {

            var isChecked = elm.currentTarget.checked;
            var idKey = Start + '|' + TimeLimitType + '|' + TimeLimitHours + '|' + TimeLimitDate + '|' + AppointmentId + '|' + AppointmentTemplateId;

            if (isChecked == true)
                vm1.checksForAppCreation.push({ key: idKey });
            else {
                //eliminar uno existente
                var idxd = -1;
                for (var idx in vm1.checksForAppCreation) {
                    if (vm1.checksForAppCreation[idx].key == idKey) {
                        idxd = parseInt(idx);
                        break;
                    }
                }

                if (idxd > -1)
                    vm1.checksForAppCreation.splice(idxd, 1);
            }
        }

        function showModal() {
            $('#appointmentScheduleDetail').modal("hide");
            $rootScope.startDatepicker = startDatepicker;
            $scope.checksForAppCreation = vm1.checksForAppCreation;
            ngDialog.open({
                template: 'app/components/appointment/appointmentCreate2.html',
                closeByDocument: false,
                closeByEscape: false
            });
        }

        function downloadExcel() {
            let criteria = Object.assign(vm1.searchSchedulerModel, {});
            criteria.IsWeek = vm1.IsWeek;
            let nameFile = $translate.instant('views.appointmentScheduler.appointmentGateIn');
            if(criteria.actionType == "P")
                nameFile = $translate.instant('views.appointmentScheduler.appointmentGateOut');

            datacontext.appointment.getPrintAppointmentReport(criteria, nameFile);
        }

        function showAppointmentModalDetails(event, Start, TimeLimitType, TimeLimitHours, TimeLimitDate, AppointmentId, AppointmentTemplateId, YardScheduleHourId) {

            var idAppt = event.currentTarget.id;

            if (!idAppt || !prueba) return;

            loop1:
                for (var s in prueba) {
                    if (prueba[s].AppointmentsSchedule) {
                        loop2:
                            for (var a in prueba[s].AppointmentsSchedule) {
                                if (prueba[s].AppointmentsSchedule[a].AppointmentId == idAppt) {

                                    vm1.apptmodal = prueba[s].AppointmentsSchedule[a];

                                    vm1.apptmodal.ReferenceDocumentNo = vm1.apptmodal.ReferenceDocumentNo.replace(",", "\n");
                                    vm1.apptmodal.EquipmentWithStatus = vm1.apptmodal.EquipmentWithStatus.replace(" \n", "\n");

                                    if (vm1.apptmodal.CanEdit) {

                                        $window.sessionStorage.editDisabled = false;

                                        vm1.canReschedule = true;
                                        vm1.editdata.Start = Start;
                                        vm1.editdata.TimeLimitType = TimeLimitType;
                                        vm1.editdata.TimeLimitHours = TimeLimitHours;
                                        vm1.editdata.TimeLimitDate = TimeLimitDate;
                                        vm1.editdata.AppointmentId = AppointmentId;
                                        vm1.editdata.AppointmentTemplateId = AppointmentTemplateId;
                                        vm1.editdata.YardScheduleHourId = YardScheduleHourId;
                                        $window.sessionStorage.yardScheduleHourId = YardScheduleHourId;

                                        $("#btnEditAppt").attr("src", "assets/img/icons/editultimate.png");
                                        $("#btnEditAppt").attr("title", $translate.instant('views.appointment.EditAppointment'));
                                    } else {

                                        $window.sessionStorage.editDisabled = true;

                                        vm1.canReschedule = false;
                                        vm1.editdata.Start = 0;
                                        vm1.editdata.TimeLimitType = 0;
                                        vm1.editdata.TimeLimitHours = 0;
                                        vm1.editdata.TimeLimitDate = 0;

                                        if (AppointmentId <= 0)
                                            vm1.editdata.AppointmentId = 0;
                                        else {
                                            vm1.editdata.Start = Start;
                                            vm1.editdata.TimeLimitType = TimeLimitType;
                                            vm1.editdata.TimeLimitHours = TimeLimitHours;
                                            vm1.editdata.TimeLimitDate = TimeLimitDate;
                                            vm1.editdata.AppointmentId = AppointmentId;
                                            vm1.editdata.AppointmentTemplateId = AppointmentTemplateId;
                                            vm1.editdata.YardScheduleHourId = YardScheduleHourId;
                                        }
                                        //ViewAppointmentReport
                                        $("#btnEditAppt").attr("src", "assets/img/icons/visualizar.png");
                                        $("#btnEditAppt").attr("title", $translate.instant('views.appointment.ViewAppointmentDetail'));
                                    }

                                    break loop1;
                                }
                            }
                    }
                }

            //muestro los detalles en el modal que es bindeado a la variable vm1.apptmodal con un delay para que termine de bindear
            //si fuese necesario
            $timeout(function () {
                $("#appointmentScheduleDetail").modal("show");
                if (vm1.apptmodal.CanEdit) {
                    $('#reScheduleArea').show();
                } else {
                    $('#reScheduleArea').hide();
                }

            }, 100);
        }

        var events = new kendo.data.ObservableArray([]);
        $scope.ds = new kendo.data.SchedulerDataSource({
            data: events,
            schema: {}
        });

        function scheduler_navigate(e) {
            vm1.checksForAppCreation = [];
            vm1.current_view = e.view + '';
            fill();
            kendo.culture($translate.instant('views.appointmentScheduler.kendolang'));
        }

        var scheduler = $scope.schedulerOptions = {
            editable: false,
            dateHeaderTemplate: kendo.template("<strong>#=kendo.toString(date, 'ddd dd/MM')#</strong>"),
            date: new Date(vm1.total),
            startTime: new Date("2016/03/14 00:00"),
            endTime: new Date("2016/03/15 00:00"),
            views: [
                {
                    type: "agenda",
                    title: "Diario",
                    eventTemplate: $("#event-template-daily").html(),
                    selected: true
                },
                {
                    type: "week",
                    title: "Semanal",
                    eventTemplate: $("#event-template-week").html(),
                    selected: false
                }
            ],
            timezone: "Etc/UTC",
            eventTimeTemplate: $("#event-time-template").html(),
            allDaySlot: false,
            majorTick: vm1.leadTime, /*recibido de base de datos*/
            isAllDay: {
                type: false,
                from: "IsAllDay"
            },
            dataSource: $scope.ds,
            showWorkHours: false,
            navigate: scheduler_navigate
        };         

        function pintarDatosCelda(e) {

            //evitar que recorra todos los slots en otro tipo de vista  
            if (vm1.current_view == "kendo.ui.WeekView") {
                var scheduler = $("#schedulerAppointment").data("kendoScheduler");
                var view = scheduler.view();
                var elements = view.content.find("td");

                //el div del evento se genera fuera de la celda por lo que no se puede acceder como child node
                view.table.find("td[role=gridcell]").each(function () {

                    var element = $(this);
                    var slot = scheduler.slotByElement(element);

                    //prueba debe iterar con slots dentro
                    if (slot) {
                        for (var s in prueba) {
                            if (prueba[s]) {
                                var dt = prueba[s];
                                if (slot.startDate - dt.start == 0) {
                                    //no pinta de 12 a 1:00 
                                    $(slot.element).css({ "text-align": "right" }, { "vertical-align": "top" });
                                    $(slot.element).html("<span style='font-size:9px;position:relative;top:-12.5px;left:2.5px'>" + dt.ApptPerLeadTime + "/" + dt.ApptPerLeadTimePerDay + "</span>"); //<a href='#' style='font-size:9px;position:relative;bottom:-12.5px;left:2.5px'>Link</a>");
                                    break;
                                }
                            }
                        }
                    }
                });
            }
        }

        function showPrintApptView(appointmentNo) {
            var apNoToSend = vm1.apptmodal.AppointmentNo;
            if (vm1.apptmodal.AppointmentNo && appointmentNo == null) {
                apNoToSend = vm1.apptmodal.AppointmentNo;
            } else if (appointmentNo != null && appointmentNo.length > 0) {
                apNoToSend = appointmentNo;
            }

            var url = $state.href('root.appointmentReport', { idap: apNoToSend, userTimeZone: new Date().getTimezoneOffset() });
            window.open(url, '_blank');
        }

        function fill() {

            //trabaja con los appointments en memoria de "vm1.getAppointments"            
            if (typeof getAppointments === 'undefined')
                var response = [];
            else
                var response = getAppointments;

            //borra los anteriores, para inicializar los eventos del dia nuevo o de la semana nueva
            events.empty();

            var event;
            var eventsArray = new Array();

            for (var i = 0; i < response.length; i++) {

                var ValidaToday = new Date();
                var mresponse = response[i];

                mresponse.start = new Date(response[i].Start);
                mresponse.end = new Date(response[i].End);
                mresponse.isAllDay = false;
                mresponse.recurrenceRule = null;
                mresponse.title = '';

                if (mresponse.ApptPerLeadTime >= 0 && mresponse.ApptPerLeadTimePerDay >= 0) {
                    mresponse.ApptPerLeadTimeResult = mresponse.ApptPerLeadTimePerDay - mresponse.ApptPerLeadTime;
                }
                if ((mresponse.start == ValidaToday) || (mresponse.start > ValidaToday)) {
                    if (mresponse.TimeLimitType == true) {
                        ValidaToday = ValidaToday.setHours(ValidaToday.getHours() + mresponse.TimeLimitHours)
                        if (mresponse.start > ValidaToday)
                            mresponse.validarCrearCita = true;
                        else
                            mresponse.validarCrearCita = false;
                    }
                    else {
                        var ValidarHora = new Date(mresponse.TimeLimitDate).getHours();
                        if (ValidarHora > mresponse.start.getHours())
                            mresponse.validarCrearCita = true;
                        else
                            mresponse.validarCrearCita = false;
                    }
                }
                else
                    mresponse.validarCrearCita = false;

                mresponse.ancla = "";
                event = mresponse;

                if (vm1.current_view == "kendo.ui.AgendaView") {
                    vm1.IsWeek = false;
                    var day = new Date(getDateFromStringForView(vm1.datevalstart, "normal")).getDate();
                    var dayEvent = new Date(event.start).getDate();

                    if (day == dayEvent) {
                        var oDate = new Date();
                        var FechEnd = minutesLess(event.end, oDate.getTimezoneOffset());
                        var EndReal = addMinutes(FechEnd, oDate.getTimezoneOffset());

                        eventsArray.push(new kendo.data.SchedulerEvent(event));
                    }
                }

                if (vm1.current_view == "kendo.ui.WeekView") {
                    vm1.IsWeek = true;
                    var oDate = new Date();
                    var FechEnd = minutesLess(event.end, oDate.getTimezoneOffset());
                    var EndReal = addMinutes(FechEnd, oDate.getTimezoneOffset());
                
                    eventsArray.push(new kendo.data.SchedulerEvent(event));
                }

            }

            if (eventsArray) {
                var dsr = $scope.schedulerAppointment.dataSource;
                dsr.data(eventsArray);
            }

            if (vm1.current_view == "kendo.ui.AgendaView") {
                $('.k-my-button').attr('disabled', 'disabled');
            } else {
                $('.k-my-button').removeAttr('disabled');
            }

            UpdateMayorTick(eventsArray);
        };

        function getDateFromStringForView(fechaString, tipo) {
            if (tipo == "default") {
                if (fechaString && fechaString.length > 2) {
                    var fpartes = fechaString.split("/");
                    if (fpartes.length && fpartes.length > 0) {
                        return fpartes[0] + "/" + fpartes[1] + "/" + fpartes[2];
                    }
                }
                return "";
            } else {
                if (fechaString && fechaString.length > 2) {
                    var fpartes = fechaString.split("/");
                    if (fpartes.length && fpartes.length > 0) {
                        return fpartes[1] + "/" + fpartes[0] + "/" + fpartes[2];
                    }
                }
                return "";
            }
        }

        function searchnewAppointment(condition) {

            switch (condition) {
                case 'today':
                    var dateToday = new Date();
                    var newtimeToday = new Date();
                    dateToday.setHours(newtimeToday.getHours());
                    dateToday.setMinutes(newtimeToday.getMinutes());
                    dateToday.setSeconds(newtimeToday.getSeconds());
                    dateToday.setDate(dateToday.getDate());
                    var verificar = new Date(getDateFromStringForView(vm1.datevalstart, "normal")).getDate();
                    var verificar2 = dateToday.getDate();
                    if (verificar != verificar2) {
                        vm1.datevalstart = dateToday;
                        vm1.datevalforhours = vm1.datevalstart;
                        $("#txtStartDate").datepicker("update", vm1.datevalstart);
                    }
                    break;

                case 'preview':

                    var datePreview = new Date(getDateFromStringForView(vm1.datevalstart, "normal"));
                    var newtimePreview = new Date();
                    datePreview.setHours(newtimePreview.getHours());
                    datePreview.setMinutes(newtimePreview.getMinutes());
                    datePreview.setSeconds(newtimePreview.getSeconds());
                    datePreview.setDate(datePreview.getDate() - 1);
                    vm1.datevalstart = datePreview;
                    vm1.datevalforhours = vm1.datevalstart;
                    $("#txtStartDate").datepicker("update", vm1.datevalstart);
                    break;

                case 'next':

                    var dateNext = new Date(getDateFromStringForView(vm1.datevalstart, "normal"));
                    var newtimeNext = new Date();
                    dateNext.setHours(newtimeNext.getHours());
                    dateNext.setMinutes(newtimeNext.getMinutes());
                    dateNext.setSeconds(newtimeNext.getSeconds());
                    dateNext.setDate(dateNext.getDate() + 1);
                    vm1.datevalstart = dateNext;
                    vm1.datevalforhours = vm1.datevalstart;
                    $("#txtStartDate").datepicker("update", vm1.datevalstart);
                    break;

                case 'other':

                    var model = vm1.searchSchedulerModel;
                    model.IsWeek = 1;
                    model.CurrentRoleCode = vm1.roleSelected;
                    model.IsOnlyPortalUser = vm1.isOnlyPortalUser;
                    //vm1.actionRefresh = true;
                    var dateNext1 = new Date((getDateFromStringForView(vm1.datevalstart, "normal")));
                    var newtimeNext1 = new Date();
                    dateNext1.setHours(newtimeNext1.getHours());
                    dateNext1.setMinutes(newtimeNext1.getMinutes());
                    dateNext1.setSeconds(newtimeNext1.getSeconds());
                    dateNext1.setDate(dateNext1.getDate());
                    vm1.searchSchedulerModel.appointmentDate = new Date(dateNext1);
                    vm1.searchSchedulerModel.dateWithOutTimeZone = minutesLess(vm1.searchSchedulerModel.appointmentDate, new Date().getTimezoneOffset());
                    var associateCarrier = common.localStorageService.get('GetBusinessPartnerUserRolesQuery');
                    model.BusinessPartnerId = associateCarrier.BusinessPartnerId;

                    var Aux = datacontext.appointment.getAppointmentsBySchedule(model).then(function (data) {

                        if (!data.AppointmentsSchedule) {
                            //vm1.actionRefresh = false;
                            toastr.warning('Se produjo un error al cargar el cronograma.');
                            return false;
                        }

                        if (data.AppointmentsSchedule.length == 0) {
                            //vm1.actionRefresh = false;
                            toastr.warning('No existe cronograma.');
                            return false;
                        }

                        $(data.AppointmentsSchedule).each(function (e, v) {
                            v.Start = new Date(v.StartString);
                            v.End = new Date(v.EndString);
                        });
                        vm1.timeZoneWeb = data.TimeZoneWeb;

                        prueba = getAppointments = data.AppointmentsSchedule;

                        //configurando la fecha minima y maxima del calendario desde base de datos
                        if (prueba && prueba.length > 0) {
                            vm1.minDate = prueba[0].MinDate;
                            vm1.maxDate = prueba[0].MaxDate;
                        } else {
                            vm1.minDate = "2016/03/14 08:00";
                            vm1.maxDate = "2016/03/14 19:00";
                        }

                        fill();
                        //vm1.actionRefresh = false;

                        var scheduler = $("#schedulerAppointment").data("kendoScheduler");

                        if (scheduler) {

                            vm1.datevalforhours = vm1.datevalstart;
                            var dateNext = new Date((getDateFromStringForView(vm1.datevalstart, "normal")));

                            var validate = isValidDate(dateNext)

                            if (validate != false) {

                                var newtimeNext = new Date();
                                dateNext.setHours(newtimeNext.getHours());
                                dateNext.setMinutes(newtimeNext.getMinutes());
                                dateNext.setSeconds(newtimeNext.getSeconds());
                                dateNext.setDate(dateNext.getDate());

                                var options = scheduler.options;

                                var $sched = $("#schedulerAppointment");
                                if ($sched) {
                                    kendo.unbind($sched);
                                    kendo.destroy($sched);
                                }

                                vm1.searchSchedulerModel.appointmentDate = vm1.total = options.date = new Date(dateNext);

                                if (vm1.current_view == "kendo.ui.AgendaView") {
                                    options.views[0].selected = true;
                                    options.views[1].selected = false;
                                }
                                else {
                                    options.views[0].selected = false;
                                    options.views[1].selected = true;
                                }

                                if (vm1.minDate && vm1.maxDate) {
                                    options.startTime = new Date(vm1.minDate);
                                    options.endTime = new Date(vm1.maxDate);
                                }

                                $("#schedulerAppointment").empty().kendoScheduler(options);

                                kendo.ui.progress($("#schedulerAppointment"), true);

                                var datefilter = vm1.searchSchedulerModel.appointmentDate;
                                if (datefilter) {
                                    var oDate = new Date();
                                    vm1.searchSchedulerModel.dateWithOutTimeZone = minutesLess(datefilter, oDate.getTimezoneOffset());
                                }

                                $('.k-scheduler-timecolumn + th').css('padding-right', '110px');
                                kendo.ui.progress($("#schedulerAppointment"), false);

                                var buttonStatus = "disabled='disabled'";
                                if (vm1.current_view == "kendo.ui.WeekView") {
                                    buttonStatus = "";
                                }

                                var scheduler = $("#schedulerAppointment").data("kendoScheduler");
                                var button = $("<div style='float:right;display:inline;padding-right:5px'><button class='k-button k-my-button'" + buttonStatus + " >Agregar Citas Múltiples</button></div>");
                                if (scheduler && scheduler.toolbar.html().indexOf("my-button") < 0) {
                                    $(scheduler.toolbar).append(button);
                                    button.click(function () {
                                        vm1.gotoCreateModal();
                                    });
                                }
                            }
                        }

                        return true;

                    }, function (err) {
                        //vm1.actionRefresh = false;
                        if (err.status)
                            toastr.error(err.info);
                    });

                    kendo.ui.progress($("#schedulerAppointment"), false);
                    break;
            }
        }

        function addMinutes(dt, minutes) {
            if (dt)
                return new Date(dt.getTime() + minutes * 60000);
            else
                return null;
        }

        function addSeconds(dt, seconds) {
            if (dt && typeof dt != 'undefined')
                return new Date(dt.getTime() + seconds * 1000);
            else
                return null;
        }

        function minutesLess(dt, minutes) {
            if (dt)
                return new Date(dt.getTime() - minutes * 60000);
            else
                return null;
        }

        function getDataScheduler(model) {

            //debe cambiar de acuerdo a lo que se seleccione
            model.IsWeek = 1;
            model.CurrentRoleCode = vm1.roleSelected;
            model.IsOnlyPortalUser = vm1.isOnlyPortalUser;
            //vm1.actionRefresh = true;

            //clear schedule component
            if ($scope.schedulerAppointment != null && $scope.schedulerAppointment != undefined) {
                var dsr = $scope.schedulerAppointment.dataSource;
                dsr.data([]);
            }
            
            var associateCarrier = common.localStorageService.get('GetBusinessPartnerUserRolesQuery');
            model.BusinessPartnerId = associateCarrier.BusinessPartnerId;

            return datacontext.appointment.getAppointmentsBySchedule(model).then(function (data) {
                if (!data.AppointmentsSchedule) {
                    //vm1.actionRefresh = false;
                    return false;
                }

                if (data.AppointmentsSchedule.length == 0) {
                    //vm1.actionRefresh = false;
                    toastr.warning('No existe cronograma.');
                    return false;
                }

                $(data.AppointmentsSchedule).each(function (e, v) {
                    v.Start = new Date(v.StartString);
                    v.End = new Date(v.EndString);
                });
                vm1.timeZoneWeb = data.TimeZoneWeb;

                prueba = getAppointments = data.AppointmentsSchedule;

                vm1.minDate = prueba[0].MinDate;
                vm1.maxDate = prueba[0].MaxDate;

                fill();
                //vm1.actionRefresh = false;
            }, function (err) {
                
                //vm1.actionRefresh = false;
                if (err.status)
                    toastr.error(err.info);
            });
        }

        function isValidDate(dateNext) {
            if (isNaN(dateNext.getTime()))
                return false;
            return dateNext;
        }

        function getFilters() {
            return datacontext.appointment.getFilters();
        }

        function yardSelected() {
            common.localStorageService.set('selectedYard', {
                yard: vm1.varyard
            });

            vm1.searchSchedulerModel.yardId = vm1.varyard;
            getDataScheduler(vm1.searchSchedulerModel);
        }

        function operationTypeSelected() {
            vm1.searchSchedulerModel.operationType = vm1.codeOperationType;
            SetMajorTick();
            getDataScheduler(vm1.searchSchedulerModel);
        }

        function actionTypeSelected() {
            vm1.searchSchedulerModel.actionType = vm1.codeActionType;
            for (var i = 0; i < vm1.actiontypeList.length; i++) {
                if (vm1.actiontypeList[i].Code == vm1.codeActionType)
                    vm1.ActionT = vm1.actiontypeList[i].Name;
            }
            SetMajorTick();
            getDataScheduler(vm1.searchSchedulerModel);
        }

        function getSearchScheduler() {
            return datacontext.appointment.getSearchScheduler();
        }

        function getHoursForReschedule() {
            //vm1.searchSchedulerModel.appointmentDate = new Date(getDateFromStringForView(vm1.datevalforhours, "normal"));
            vm1.searchSchedulerModel.appointmentDate = moment(vm1.datevalforhours, formatos, true).toDate();
            if (vm1.searchSchedulerModel.appointmentDate < new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())) {
                $('#btnReschedule').attr('disabled', 'disabled');
            }
            else {
                $('#btnReschedule').attr('disabled', 'disabled');
                return datacontext.appointment.getHoursForReschedule(vm1.searchSchedulerModel).then(function (data) {
                    if (data.Appointment && data.Appointment.length > 0) {
                        $(data.Appointment).each(function (e, v) {
                            v.AppointmentDate = moment(v.AppointmentDateString, "DD/MM/yyyy HH:mm").format("YYYY-MM-DDTHH:mm:ssZ");
                        });

                        var first = data.Appointment[0].NotWorkingDay;
                        if (first != null && first) {
                            //cuando el dia es no laborable
                            vm1.hourstoreschedule = [{ TaskID: 0, Title: "--Día no laborable--" }];
                        } else {
                            //cuando hay horarios disponibles para esa fecha
                            vm1.hourstoreschedule = data.Appointment;
                            $('#btnReschedule').removeAttr('disabled');
                        }
                    } else {
                        vm1.hourstoreschedule = [{ TaskID: 0, Title: "--No hay horarios disponibles--" }];
                    }
                    vm1.varhour = vm1.hourstoreschedule[0].TaskID;
                }, function (err) {
                    if (err.status)
                        toastr.error(err.info);
                });
            }
        }

        function saveReschedule(e) {

            //vm1.actionRefresh = false;
            $('#btnReschedule').attr('disabled', 'disabled');
            return datacontext.appointment.getAppointmentById(vm1.apptmodal.AppointmentId).then(function (data) {

                var datappointment = data.Appointment;

                if (datappointment) {

                    var selobj;
                    for (var idx = 0; idx < vm1.hourstoreschedule.length; idx++) {
                        if (vm1.varhour == vm1.hourstoreschedule[idx].TaskID) {
                            selobj = vm1.hourstoreschedule[idx];
                            break;
                        }
                    }

                    if (vm1.hourstoreschedule && vm1.hourstoreschedule.length > 0 && vm1.apptmodal && selobj) {
                        datappointment.ForReschedule = true;
                        datappointment.AppointmentDateString = selobj.AppointmentDate + "";
                        datappointment.AppointmentId = vm1.apptmodal.AppointmentId;
                        datappointment.AppointmentDate = new Date(datappointment.AppointmentDateString);
                        datappointment.TimeZone = new Date().getTimezoneOffset();

                        if (vm1.hourstoreschedule[0].FromAppTemplate == true) {
                            datappointment.AppointmentTemplateId = vm1.varhour;
                        } else {
                            datappointment.AppointmentTemplateId = -1;
                        }

                        return datacontext.appointment.saveAppointmentReschedule(datappointment).then(function (data) {
                            if(data.Result == 1){
                                let messageSuccess = "Se reagendó el appointment con éxito";

                                if (data.message !== "" && data.message !== null)
                                    messageSuccess += data.Message;

                                toastr.info(messageSuccess);
                                $("#appointmentReScheduleDetail").modal("hide");
                                searchnewAppointment("other");
                            }
                            else if (data.Result == 8){
                                toastr.warning(data.Message);
                            }
                            else{
                                toastr.error(data.Message);
                            }
                            $('#btnReschedule').removeAttr('disabled');
                            
                        }, function (err) {

                            $('#btnReschedule').removeAttr('disabled');
                            if (err.status)
                                toastr.error(err.info);
                        });
                    }

                }
                //vm1.actionRefresh = true;
            }, function (err) {
                $('#btnReschedule').removeAttr('disabled');
                //toast.err(err);
                //vm1.actionRefresh = true;
                if (err.status)
                    toastr.error(err.info);
            });
        }

        function getDeleteAppointment() {
            return datacontext.appointment.getDeleteAppointment();
        }

        function deleteAppointment(IdAp, IdTem) {


            var r = confirm($translate.instant('views.appointmentScheduler.deleteAppointment'));
            if (r == true) {
                //vm1.actionRefresh = true;
                vm1.deleteAppointmentModel.appointmentId = IdAp;
                vm1.deleteAppointmentModel.appointmentTemplateId = IdTem;

                var Aux = datacontext.appointment.cancelAppointment(vm1.deleteAppointmentModel).then(function (data) {
                    if (data.Status) {
                        searchnewAppointment("other");
                        toastr.info(data.Message);
                    } else
                        toastr.error(data.Message);

                    //return Aux;
                    return true;
                }, function (err) {
                    if (err.status)
                        toastr.error(err.info);
                    });
                //vm1.actionRefresh = false;
            }
            else
                return false;
        }

        function clickOpen(IdAppOC, IdIma) {
            if ($('#' + IdAppOC).css('visibility') == 'hidden') {
                $('#' + IdAppOC).css('visibility', 'visible');
                $('#' + IdIma).attr('src', 'assets/img/icons/ic_cerrar.png');
            } else {
                $('#' + IdAppOC).css('visibility', 'hidden');
                $('#' + IdIma).attr('src', 'assets/img/icons/ic_abrir.png');
            }
        }

        function gotoCreate2(Alpha, Type, TypeHours, TypeDate, AppointmentId, AppointmentTemplateId, YardScheduleHourId) {
            //uncheck and remove previous selected appointments
            vm1.checksForAppCreation = [];
            common.localStorageService.set('apptsInfo', { apptsinfo: null });
            $('div.k-event-template span input[type=checkbox]').prop('checked', false);

            var Validate = new Date();
            var validarCrearCita;
            AppointmentId = parseInt(AppointmentId);
            Type = Boolean(Type);
            TypeDate = new Date(TypeDate);
            TypeHours = parseInt(TypeHours);
            AppointmentTemplateId = parseInt(AppointmentTemplateId);
            Alpha = new Date(Alpha);

            //si la fecha de la cita es igual o mayor a la fecha actual, permite crear o editar
            if ((Alpha == Validate) || (Alpha > Validate)) {

                //La validación de anticipacion permitida para la cita solo es valida para la creación
                if (AppointmentId == -1) {
                    $window.sessionStorage.editDisabled = false;
                    if (Type == true) {
                        Validate = Validate.setHours(Validate.getHours() + TypeHours)
                        if (Alpha > Validate)
                            validarCrearCita = true;
                        else
                            validarCrearCita = false;
                    }
                    else {
                        var ValidarHora = TypeDate.getHours();
                        if (ValidarHora > Alpha.getHours())
                            validarCrearCita = true;
                        else
                            validarCrearCita = false;
                    }
                } else {
                    if (AppointmentId > 0) {
                        //fecha de la cita mayor a la fecha actual
                        if (Alpha > Validate)
                            validarCrearCita = true;
                        else
                            validarCrearCita = false; //flag para campos en gris

                        var hoursDifference = Math.abs(Alpha - Validate) / 36e5;
                        if (TypeHours > hoursDifference)
                            $window.sessionStorage.editDisabled = true;
                        else
                            $window.sessionStorage.editDisabled = false;
                    }
                }
            } else {
                //si la fecha de la cita es anterior al dia de hoy entonces no te va a dejar crear 
                //pero podria dejar editar en modo deshabilitado para que solo vea los datos de la cita
                //por ahora no deja entrar 
                if (AppointmentId == -1) {
                    validarCrearCita = false;
                } else {
                    //en la edicion hace como que crea una cita para que mande toda la informacion interna
                    //pero tambien manda el flag para que deshabilite los campos cambiables y el boton de edicion
                    validarCrearCita = true;
                    $window.sessionStorage.editDisabled = true;
                }
            }

            if (validarCrearCita == true) {
                var hours = Alpha.getHours();
                var minutes = Alpha.getMinutes();
                var ampm = hours >= 12 ? 'PM' : 'AM';

                hours = hours % 12;
                hours = hours ? hours : 12; // the hour '0' should be '12'
                minutes = minutes < 10 ? '0' + minutes : minutes;

                var HourString = hours + ':' + minutes + ' ' + ampm;
                var DateString = ("0" + (Alpha.getMonth() + 1)).slice(-2) + "/" + ("0" + Alpha.getDate()).slice(-2) + "/" + Alpha.getFullYear();

                $window.sessionStorage.idYard = angular.copy(vm1.varyard);
                common.localStorageService.set('selectedYard', {
                    yard: vm1.varyard
                });

                $window.sessionStorage.codeActionType = angular.copy(vm1.codeActionType);
                $window.sessionStorage.codeOperationType = angular.copy(vm1.codeOperationType);
                $window.sessionStorage.dateString = angular.copy(DateString);
                $window.sessionStorage.hourString = angular.copy(HourString);
                pruebafecha = $window.sessionStorage.date = angular.copy(Alpha);
                $window.sessionStorage.appointmentId = angular.copy(AppointmentId);
                $window.sessionStorage.appointmentTemplateId = angular.copy(AppointmentTemplateId);
                $window.sessionStorage.alpha = angular.copy(Alpha);
                $window.sessionStorage.type = angular.copy(Type);
                $window.sessionStorage.typeHours = angular.copy(TypeHours);
                $window.sessionStorage.typeDate = angular.copy(TypeDate);
                $window.sessionStorage.yardScheduleHourId = angular.copy(YardScheduleHourId);
                $rootScope.__AppointmentTemplateId__ = angular.copy(AppointmentTemplateId);

                let appointmentTemplate = getAppointments.find(x => x.YardScheduleHourId == YardScheduleHourId);
                $rootScope.createAppointment = { 
                    localAppointmentDate: appointmentTemplate.StartString,
                    endDate: appointmentTemplate.End
                };
                //nuevo
                vm1.showModal();
            }
            else {
                toastr.error('Expiro el tiempo para la creación');
            }
        }

        //metodo separado para seleccion multiple
        //valida cada cita del arreglo de checks seleccionados
        //si alguna no es valida reporta al usuario
        function gotoCreateModal() {

            if (vm1.checksForAppCreation && vm1.checksForAppCreation.length == 0) {
                toastr.info('Por favor marcar dos o más celdas en los horarios deseados para crear las citas');
                return false;
            }

            if (vm1.checksForAppCreation && vm1.checksForAppCreation.length == 0) {
                toastr.info('Por favor seleccionar directamente la celda de la cita individual con su ícono "+" correspondiente');
                return false;
            }

            vm1.selectedApptsInfo = [];
            if (vm1.checksForAppCreation && vm1.checksForAppCreation.length > 0) {

                var citasValida = true;
                for (var hr in vm1.checksForAppCreation) {

                    var valid_date = new Date();
                    var validar_crear_cita = false;

                    var alpha; var typeP; var typeHours;
                    var typeDate; var appointmentId; var appointmentTemplateId;

                    var reg = vm1.checksForAppCreation[hr];
                    var regParts = reg.key.split("|");

                    alpha = new Date(regParts[0]);
                    typeP = JSON.parse(regParts[1]);
                    typeHours = parseInt(regParts[2]);
                    typeDate = new Date(regParts[3]);
                    appointmentId = parseInt(regParts[4]);
                    appointmentTemplateId = parseInt(regParts[5]);

                    //si la fecha de la cita es igual o mayor a la fecha actual, permite crear o editar
                    if ((alpha == valid_date) || (alpha > valid_date)) {

                        //La validación de anticipacion permitida para la cita solo es valida para la creación
                        if (appointmentId == -1) {
                            if (typeP == true) {
                                valid_date = valid_date.setHours(valid_date.getHours() + typeHours)
                                if (alpha > valid_date)
                                    validar_crear_cita = true;
                                else
                                    validar_crear_cita = false;
                            } else {
                                var ValidarHora = typeDate.getHours();
                                if (ValidarHora > alpha.getHours())
                                    validar_crear_cita = true;
                                else
                                    validar_crear_cita = false;
                            }
                        } else {
                            if (appointmentId > 0) {
                                //fecha de la cita mayor a la fecha actual
                                if (alpha > valid_date) {
                                    validar_crear_cita = true;
                                } else {
                                    validar_crear_cita = false;
                                }
                            }
                        }
                    } else {
                        if (appointmentId == -1)
                            validar_crear_cita = false;
                        else
                            validar_crear_cita = true;
                    }

                    if (validar_crear_cita == true) {

                        var hours = alpha.getHours();
                        var minutes = alpha.getMinutes();
                        var ampm = hours >= 12 ? 'PM' : 'AM';

                        hours = hours % 12;
                        hours = hours ? hours : 12; // the hour '0' should be '12'
                        minutes = minutes < 10 ? '0' + minutes : minutes;

                        var HourString = hours + ':' + minutes + ' ' + ampm;
                        var DateString = ("0" + (alpha.getMonth() + 1)).slice(-2) + "/" + ("0" + alpha.getDate()).slice(-2) + "/" + alpha.getFullYear();

                        /*
                            Se debe armar otro arreglo con la data que se manda por sessionStorage para cada fecha: 
                            la anterior mas: DateString,HourString
                        */

                        $window.sessionStorage.idYard = angular.copy(vm1.varyard);
                        common.localStorageService.set('selectedYard', {
                            yard: vm1.varyard
                        });
                        $window.sessionStorage.codeActionType = angular.copy(vm1.codeActionType);
                        $window.sessionStorage.codeOperationType = angular.copy(vm1.codeOperationType);

                        var apptInfo = reg.key + '|' + DateString + '|' + HourString;
                        vm1.selectedApptsInfo.push({ key: apptInfo });
                        common.localStorageService.set('apptsInfo', {
                            apptsinfo: vm1.selectedApptsInfo
                        });
                    }
                    else {
                        citasValida = false;
                    }

                    if (!citasValida) {
                        vm1.checksForAppCreation = [];
                        $('div.k-event-template span input[type=checkbox]').prop('checked', false);
                        toastr.error("El horario es inválido porque ha expirado.\nPor favor seleccione un nuevo horario y vuelva a intentar");
                        break;
                    }
                }

                //si validó todas las citas cargadas en el arreglo abre el modal                                
                if (citasValida) {
                    $window.sessionStorage.selectedApptsInfo = angular.copy(vm1.selectedApptsInfo);
                    $window.sessionStorage.editDisabled = false;
                    vm1.showModal();
                }
            }
            return false;
        }

        //calendario principal
        function startDate() {
            $('#txtStartDate').focus();
        }

        //busca los appointments con una fecha escogida en el calendario principal
        function startDatepicker() {
            searchnewAppointment('other');
        }

        //calendario agendamiento
        function startDateHours() {
            $('#txtStartDateForHours').focus();
        }

        //busca los horarios para el combobox, con una fecha escogida en el calendario del reagendamiento
        function startDatepickerHours() {
            if (ValidDate(vm1.datevalforhours)) {
                //el ng-change (evento) ya maneja el apply y actualiza la lista con los nuevos valores
                getHoursForReschedule();
            }
        }

        function ValidDate(date) {
            //console.log("Date: "+date + "; Valid:" + moment(date, formatos, true).isValid() + "; Value: " + moment(vm1.datevalforhours, formatos, true).toDate());
            return moment(date, formatos, true).isValid();
        }

        //cambia el elemento seleccionado en el boton
        function getInitialAction() {
            $window.sessionStorage.type = angular.copy($stateParams.type);
            vm1.initialAction = angular.copy($window.sessionStorage.type);

            if (!vm1.initialAction) {
                vm1.initialAction = "D";
                $window.sessionStorage.type = "D";
            }

            //setea la opcion activa del schedule en el menu de botones
            $('.group-appt-actions label').each(function () {
                $(this).removeClass('active');
                var actionid = $(this).attr('actionid');

                if ((actionid == 2 && vm1.initialAction == "D")) {
                    $(this).addClass('active');
                }
                if (actionid == 3 && vm1.initialAction == "P") {
                    $(this).addClass('active');
                }
            });
            return vm1.initialAction;
        }

        function principal() {
            $state.go("root", { reload: true });
        }

        function redirectAction(Type) {
            switch (Type) {
                case 'C':
                    $window.sessionStorage.type = angular.copy(Type);
                    $state.go("root.appointment", $stateParams, {
                        reload: false, inherit: false, notify: true
                    });
                    break;
                case 'D':
                    $window.sessionStorage.type = angular.copy(Type);
                    $state.go("root.appointmentMainApptSchedule", $stateParams, {
                        reload: false, inherit: false, notify: true
                    });
                    break;
                case 'P':
                    $window.sessionStorage.type = angular.copy(Type);
                    $state.go("root.appointmentMainApptSchedule2", $stateParams, {
                        reload: false, inherit: false, notify: true
                    });
                    break;
            }
        }

        function GetYards() {
            datacontext.appointment.getYards()
                .then(function (result) {
                    if (result)
                        vm1.yards = result;
                }, function (err) {
                    if (err.status)
                        toastr.error(err.info);
                });
        }

        function GetYardList() {
            var yardLst = [];
            angular.forEach(common.localStorageService.get('yardList'), function (value, key) {
                var yards = $(vm1.yards).filter(function (a, b) { return b.Code == value.code });
                if (yards && yards.length > 0) {
                    var yaradId = yards[0].YardId;
                    var yardObj = {};
                    yardObj.Code = value.code;
                    yardObj.Name = value.name;
                    yardObj.YardId = yaradId;
                    yardLst.push(yardObj);
                }
            });
            return yardLst;
        }

        function UpdateMayorTick(eventsArray) {
            if (vm1.current_view == "kendo.ui.WeekView") {
                var scheduler = $("#schedulerAppointment").data("kendoScheduler");

                if (scheduler) {
                    var options = scheduler.options;
                    var shouldBe30MinuteMajorTick = false;

                    if (eventsArray) {
                        $(eventsArray).each(function (value, key) {
                            var startDateMinutes = key.start.getMinutes();
                            var endDateMinutes = key.end.getMinutes();
                            if (startDateMinutes !== 0 || endDateMinutes !== 0) {
                                shouldBe30MinuteMajorTick = true;
                                return;
                            }
                        });
                    }

                    options.majorTick = shouldBe30MinuteMajorTick ? 30 : vm1.leadTime;
                }
            }
        }

        function copyToClipboard(appointmentNo) {
            event.preventDefault();
            event.stopPropagation();
            var copyControl = document.createElement('textarea');
            copyControl.value = appointmentNo;
            copyControl.setAttribute('readonly', '');
            copyControl.style = { position: 'absolute', left: '-9999px', display: 'none' };
            if (copyControl) {
                document.body.appendChild(copyControl);
                copyControl.select();
                document.execCommand('copy');
                document.body.removeChild(copyControl);
                toastr.info($translate.instant('views.appointment.AppointmentNoCopiedToClipboard'));                
            }
        };

        vm1.onMouseOver = function (apptId) {
            var ctrl = $("#app-" + apptId + "");
            ctrl.css("visibility", "visible");
        };

        vm1.onMouseLeave = function (apptId) {
            var ctrl = $("#app-" + apptId + "");
            if (ctrl.css("visibility") === 'visible')
                ctrl.css("visibility", "hidden");
        };

        function init() {
            $('#txtStartDateForHours').datepicker({
                autoclose: true,
                format: 'dd/mm/yyyy'
            });

            //vm1.actionRefresh = true;
            common.activateController([getInitialAction(), getFilters(), getSearchScheduler(), getDeleteAppointment(), GetYards()])
                .then(function (data) {
                    $window.sessionStorage.type = angular.copy($stateParams.type);

                    var authData = common.localStorageService.get('authorizationData');
                    vm1.roleSelected = authData ? authData.userRole : "";
                    vm1.isOnlyPortalUser = authData ? authData.isOnlyPortalUser : "";

                    //resetea la seleccion multiple
                    common.localStorageService.set('apptsInfo', {
                        apptsinfo: null
                    });

                    vm1.yardsList = GetYardList();
                    if (data) {
                        vm1.searchSchedulerModel = data[2];
                        vm1.deleteAppointmentModel = data[3];

                        $window.sessionStorage.editDisabled = false;

                        if (common.localStorageService.get('selectedYard') != null) {
                            vm1.varyard = common.localStorageService.get('selectedYard').yard;
                        } else {
                            vm1.varyard = data[1].Yards[0].YardId;
                        }
                        vm1.searchSchedulerModel.yardId = vm1.varyard;

                        vm1.operationtypeList = data[1].OperationTypes;
                        vm1.varoperationtype = data[1].OperationTypes[2].OperationTypeId;
                        vm1.codeOperationType = data[1].OperationTypes[2].Code;
                        vm1.searchSchedulerModel.operationType = vm1.codeOperationType;

                        vm1.actiontypeList = data[1].ActionTypes;
                        if (vm1.initialAction != "true") {
                            for (var i = 0; i < vm1.actiontypeList.length; i++)
                                if (vm1.actiontypeList[i].Code == vm1.initialAction) {
                                    vm1.varactiontype = vm1.actiontypeList[i].ActionTypeId;
                                    vm1.codeActionType = vm1.actiontypeList[i].Code;
                                    vm1.ActionT = vm1.actiontypeList[i].Name;
                                } else {
                                    if (!vm1.initialAction) {
                                        vm1.varactiontype = vm1.actiontypeList[1].ActionTypeId;
                                        vm1.codeActionType = vm1.actiontypeList[1].Code;
                                        vm1.ActionT = vm1.actiontypeList[1].Name;
                                    }
                                }
                        } else {
                            vm1.varactiontype = vm1.actiontypeList[1].ActionTypeId;
                            vm1.codeActionType = vm1.actiontypeList[1].Code;
                            vm1.ActionT = vm1.actiontypeList[1].Name;
                        }
                        vm1.searchSchedulerModel.actionType = vm1.codeActionType;

                        if (pruebafecha) {
                            $("#txtStartDate").datepicker("update", pruebafecha);
                        } else
                            $("#txtStartDate").datepicker("update", vm1.datevalstart);


                        SetMajorTick();

                        //cuando el scheduler se ha terminado de instanciar
                        angular.element(document).ready(function () {

                            var scheduler = $("#schedulerAppointment").data("kendoScheduler");

                            $("#reScheduleArea").click(function () {
                                $("#appointmentScheduleDetail").modal("hide");
                                $("#appointmentReScheduleDetail").modal("show");

                                vm1.datevalforhours = vm1.datevalstart;
                                //recupera las horas a presentar segun la fecha del schedule principal                          
                                getHoursForReschedule();
                            });

                        });
                    }
                    //vm1.actionRefresh = false;

                    var permissionPage = configConstants.enums.pages.gateOut;
                    switch (vm1.varactiontype) {
                        case "D": {
                            permissionPage = configConstants.enums.pages.gateIn;
                        } break;
                        case "P": {
                            permissionPage = configConstants.enums.pages.gateOut;
                        } break;
                    }
                    vm1.permissionHide = common.getPermissionByPage(permissionPage);
                },
                    function (err) {
                        //vm1.actionRefresh = false;
                        if (err.status)
                            toastr.error(err.info);
                    });
        }

        function SetMajorTick() {
            datacontext.appointment.getLeadTime(vm1.codeActionType,vm1.codeOperationType)
            .then((data) => {
                if (!isNaN(data)) 
                    vm1.leadTime = data;
            });
        }

    } //controller

})();